import { useMutation } from '@tanstack/react-query'
import { useAuth } from '../providers'
import { v1Client } from '../api'

/**
 * Hook to create a Stripe portal session for managing payment methods
 */
export const useStripePortalSession = () => {
  const { getAuthToken } = useAuth()

  return useMutation({
    mutationFn: async () => {
      const token = await getAuthToken()
      const response = await v1Client.POST('/billing/stripe-portal-session', {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      })

      if (response.error) {
        throw new Error(`Failed to create portal session: ${JSON.stringify(response.error)}`)
      }

      return response.data.data
    },
    onSuccess: (data) => {
      window.ampltd.trackEvent('Billing', {
        action: 'stripe portal opened',
        source: 'portal session',
      })

      // Open the portal URL in the user's default browser
      window.open(data.portalUrl, '_blank')
    },
    onError: (error) => {
      console.error('Stripe portal session error:', error)
      window.ampltd.trackEvent('Billing', {
        action: 'stripe portal error',
        error: error instanceof Error ? error.message : 'Unknown error',
      })
    },
  })
}
